import { render, staticRenderFns } from "./ManagementSection.vue?vue&type=template&id=511e8f08&scoped=true&"
import script from "./js/management-section.js?vue&type=script&lang=js&"
export * from "./js/management-section.js?vue&type=script&lang=js&"
import style0 from "./ManagementSection.vue?vue&type=style&index=0&id=511e8f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e8f08",
  null
  
)

export default component.exports